import { Table, TableContainer } from '@shared/components';
import type { TableBodyProps, TableHeaderProps } from '@shared/table-generator';

import QSetSimilarityMatrixBody from './qset-similarity-matrix-body';
import QSetSimilarityMatrixHeader from './qset-similarity-matrix-header';

export interface QSetSimilarityMatrixProps {
  columns: TableHeaderProps['columns'];
  columnSlotProps: TableHeaderProps['slotProps'];
  rows: TableBodyProps['rows'];
  rowSlotProps: TableBodyProps['slotProps'];
}

export default function QSetSimilarityMatrix(props: Readonly<QSetSimilarityMatrixProps>) {
  const { columns, columnSlotProps, rows, rowSlotProps } = props;
  return (
    <TableContainer sx={{ display: 'flex' }}>
      <Table
        stickyHeader
        sx={{
          borderSpacing: '4px',
          width: 'auto',
          mx: 'auto',
        }}
      >
        <QSetSimilarityMatrixHeader columns={columns} columnSlotProps={columnSlotProps} />
        <QSetSimilarityMatrixBody rows={rows} rowSlotProps={rowSlotProps} />
      </Table>
    </TableContainer>
  );
}
